import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Alert,
} from "@mui/material";
import { fetchFreeVotes } from "../../action/freeVotesAction";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default function Goals() {
  const freeVotesData = useSelector((state) => state.freeVotes);
  const token = useSelector((state) => state.auth.token);

  const dispatch = useDispatch();

  const [freeVotes, setFreeVotes] = useState("");
  const [initialValues, setInitialValues] = useState({ freeVotes: "" });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object().shape({
      freeVotes: Yup.number("Please enter integer value")
        .required("Please Enter the Free Votes")
        .typeError("Free votes must be an integer"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/setFreeVotes`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          dispatch(fetchFreeVotes(token));
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
      }
    },
  });

  useEffect(() => {
    dispatch(fetchFreeVotes(token));
  }, [dispatch, token]);

  useEffect(() => {
    if (freeVotesData?.data?.success) {
      setFreeVotes(freeVotesData?.data?.data?.free_votes);
      setInitialValues({ freeVotes: freeVotesData?.data?.data?.free_votes });
    }
  }, [freeVotesData]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Free Votes
          </Typography>
        </Box>
        <Box className="page_inner">
          <Box className="free_votes">
            <Typography variant="h4" component="h4" className="td-text">
              Enter the Quota for FREE Votes that user will get while on
              onboarding
            </Typography>
            <Box className="free_vote_form">
              <form onSubmit={formik.handleSubmit} className="free_vote_form">
                {formik.touched.freeVotes && formik.errors.freeVotes ? (
                  <Alert style={{ margin: "10px 0" }} severity="error">
                    {formik.errors.freeVotes}
                  </Alert>
                ) : (
                  ""
                )}
                <TextField
                  id="outlined-basic"
                  placeholder="Enter Free Votes"
                  name="freeVotes"
                  onChange={formik.handleChange}
                  type="text"
                  // value={freeVotes}
                  value={formik.values.freeVotes}
                />
                <Box className="free_votes_buttons">
                  <Button variant="outlined">cancel</Button>
                  <Button variant="outlined" type="submit">
                    Save
                  </Button>
                </Box>
              </form>
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}
